module.exports = __webpack_public_path__ + "static/adelle_regular-webfont-woff-1c9f34db0cc220075b2803172f8158a8.woff";